import React from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';

const Copy = props => {
  return (
    <Wrapper {...props}>
      <h1>Traditionally Romantic</h1>
      <p>
        In 1873, John Christian Dieter and Margaretha Saur began a Royal City
        tradition that has endured to this day. An inherently romantic city,
        ideal for those wanting to start a new life together, the couple was the
        first to marry in New Westminster. Today, the countless Love Locks at
        Westminster Pier Park and the diverse wedding stores on Columbia street
        continue the city’s tradition of being a naturally romantic place to
        call home.
      </p>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-top: 50px;
  padding-bottom: 50px;
  h1 {
    color: ${props => props.theme.colorPrimary};
    font-family: ${({ theme }) => theme.fontHeader};
    text-transform: uppercase;
    font-size: 28px;
    max-width: 370px;
    margin: 0 auto 30px;
  }
  p {
    font-family: ${({ theme }) => theme.fontMain};
    color: rgba(0, 0, 0, 0.72);
    font-size: 16px;
    line-height: 24px;
    @media (min-width: ${media.mdup}) {
      font-size: 18px;
    }
  }
  em {
    color: ${props => props.theme.colorPrimary};
    font-style: normal;
  }
  @media (min-width: 630px) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) translateZ(0);
    opacity: ${props => (props.active ? '1' : '0')};
    transition: opacity 0.5s;
  }
`;

export default Copy;



// WEBPACK FOOTER //
// ./src/components/Gallery/elements/Copy.js